import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobiPagesComponent } from './mobi-pages/mobi-pages.component';
import { MaterialModuleMobi } from '../material/material.module';
import { WidgetPropertyFormsModule } from '../widgetPropertyForms/widget-property-forms.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { AppPermissionsPipe, SharedModule } from 'shared-library';
import { ObserveVisibilityDirective } from './directives/observe-visibility.directive';
import { PageComponent } from './components/page/page.component';



@NgModule({
  declarations: [
    MobiPagesComponent,
    ObserveVisibilityDirective,
    PageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModuleMobi,
    WidgetPropertyFormsModule,
    DragDropModule,
    SharedModule,
    AppPermissionsPipe,
    
  ],
  exports: [
    MobiPagesComponent
  ]
})
export class MobiPagesModule { }
